import { UIState } from "../states/UIState";
import { ReducerAction } from '../ReducerAction';
import { ActionType } from '../ActionsTypes';

export const uiReducer = (state = new UIState({
    isDepositAccountsOpen: false,
    isCommissionsOpen: false,
    isPasswordOpen: false,
    isSessionTimeOpen: false,
    isModalMovOpen: false,
    isLoginCheckLoading: true,
    isModalHelpOpen: false,
    isLoadingActive: false,
    isShowBalance: true,
    isTwoFactorOpen: false,
}), action: ReducerAction) => {
    switch (action.type) {
        case ActionType.UI_CLOSE_DEPOSIT_ACCOUNTS:
            return new UIState({
                ...state,
                isDepositAccountsOpen: false
            });
        case ActionType.UI_OPEN_DEPOSIT_ACCOUNTS:
            return new UIState({
                ...state,
                isDepositAccountsOpen: true
            });

        case ActionType.UI_OPEN_COMMISSIONS:
            return new UIState({
                ...state,
                isCommissionsOpen: true
            });

        case ActionType.UI_CLOSE_COMMISSIONS:
            return new UIState({
                ...state,
                isCommissionsOpen: false
            });

        case ActionType.UI_SHOW_BALANCE:
            return new UIState({
                ...state,
                isShowBalance: true
            });

        case ActionType.UI_HIDE_BALANCE:
            return new UIState({
                ...state,
                isShowBalance: false
            })

        case ActionType.UI_OPEN_TWOFACTOR:
            return new UIState({
                ...state,
                isTwoFactorOpen: true
            });

        case ActionType.UI_CLOSE_TWOFACTOR:
            return new UIState({
                ...state,
                isTwoFactorOpen: false
            });

        case ActionType.UI_OPEN_PASSWORD:
            return new UIState({
                ...state,
                isPasswordOpen: true
            })

        case ActionType.UI_CLOSE_PASSWORD:
            return new UIState({
                ...state,
                isPasswordOpen: false
            })

        case ActionType.UI_OPEN_SESSION_TIME:
            return new UIState({
                ...state,
                isSessionTimeOpen: true
            });

        case ActionType.UI_CLOSE_SESSION_TIME:
            return new UIState({
                ...state,
                isSessionTimeOpen: false
            })

        case ActionType.UI_OPEN_MODAL_MOV:
            return new UIState({
                ...state,
                isModalMovOpen: true
            })

        case ActionType.UI_CLOSE_MODAL_MOV:
            return new UIState({
                ...state,
                isModalMovOpen: false
            })

        case ActionType.UI_SET_LOGIN_CHECK_LOADING:
            return new UIState({
                ...state,
                isLoginCheckLoading: action.payload
            })

        case ActionType.UI_OPEN_MODAL_HELP:
            return new UIState({
                ...state,
                isModalHelpOpen: true
            })

        case ActionType.UI_CLOSE_MODAL_HELP:
            return new UIState({
                ...state,
                isModalHelpOpen: false
            })

        //Loading
        case ActionType.LOADING_ACTIVE:
            return new UIState ({
                ...state,
                isLoadingActive: true
            })

        case ActionType.LOADING_INACTIVE:
            return new UIState ({
                ...state,
                isLoadingActive: false
            })


        default:
            return state;
    }
}